import { FacetedFilter, type Option } from '@neo/blocks/faceted-filter'
import { Tabs, TabsList, TabsTrigger } from '@neo/primitives/tabs'
import type { ReactNode } from 'react'

type SimulationTab = 'scenarios' | 'results'

interface SimulationToolbarProps {
  activeTab: SimulationTab
  onTabChange: (tab: SimulationTab) => void
  tagOptions?: Option[]
  selectedTags?: string[]
  onTagsChange?: (tags: string[]) => void
  children?: ReactNode
}

export const SimulationToolbar = ({
  activeTab,
  onTabChange,
  tagOptions,
  selectedTags,
  onTagsChange,
  children,
}: SimulationToolbarProps) => (
  <div className="flex flex-wrap items-center gap-3 border-b border-border bg-card px-6 py-3">
    <Tabs value={activeTab} onValueChange={(v) => onTabChange(v as SimulationTab)}>
      <TabsList
        variant="default"
        className="h-9 w-auto gap-1 rounded-md border border-border bg-bg2 p-1"
      >
        <TabsTrigger
          variant="default"
          value="scenarios"
          className="h-7 min-w-32 justify-center rounded px-3 font-inter text-s-500 normal-case tracking-normal shadow-none"
        >
          Test scenarios
        </TabsTrigger>
        <TabsTrigger
          variant="default"
          value="results"
          className="h-7 min-w-32 justify-center rounded px-3 font-inter text-s-500 normal-case tracking-normal shadow-none"
        >
          Simulation results
        </TabsTrigger>
      </TabsList>
    </Tabs>
    {onTagsChange && tagOptions && tagOptions.length > 0 && (
      <FacetedFilter
        title="Keywords"
        options={tagOptions}
        value={selectedTags}
        onChange={(val: string | string[] | undefined) =>
          onTagsChange(Array.isArray(val) ? val : val ? [val] : [])
        }
      />
    )}
    <div className="flex-1" />
    {children}
  </div>
)
